// extracted by mini-css-extract-plugin
export default {"chatContainer":"start_experience_style_chatContainer__dy8XO"};